import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getTablesRequest = (token, startDate, endDate, restaurant) => {
  const organizationId = localStorage.getItem("organizationId");
  // &restaurantId=${restaurantId}
  const url =
    apiURl +
    "tables/GetDailyStatisticsForTablesQuery?organizationId=" +
    organizationId +
    "&restaurantId=" +
    restaurant +
    "&startDate=" +
    startDate +
    "&endDate=" +
    endDate;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getBillDetailsRequest = (token, billId) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "tables/GetBillDetails?billId=" +
    billId +
    "&organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getTablesRequest, getBillDetailsRequest };
